/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CalculateProductCostResponseDto { 
    dateCalculated?: string;
    newslettersTier3Cost?: number;
    newslettersTier2Cost?: number;
    newslettersTier1Cost?: number;
    boostCost?: number;
    publishCost?: number;
    sum?: number;
}

